/**
 * Программная расстановка мягких переносов (U+00AD) для русского текста.
 * Работает с uppercase — браузер переносит по soft hyphen даже при text-transform: uppercase.
 */
import hyphenopoly from 'hyphenopoly';
import ruWasmUrl from 'hyphenopoly/patterns/ru.wasm?url';

let hyphenateRuFn: ((text: string) => string) | null = null;

async function initHyphenator(): Promise<(text: string) => string> {
  if (hyphenateRuFn) return hyphenateRuFn;
  const hyphenators = hyphenopoly.config({
    require: ['ru'],
    hyphen: '\u00AD',
    loader: async (file: string) => {
      if (file === 'ru.wasm') {
        const res = await fetch(ruWasmUrl);
        return new Uint8Array(await res.arrayBuffer());
      }
      throw new Error(`Unknown pattern: ${file}`);
    },
  });
  const fn = await hyphenators.get('ru');
  if (!fn) throw new Error('Russian hyphenator not loaded');
  hyphenateRuFn = fn;
  return fn;
}

/** Гифенирует русский текст (вставляет мягкие переносы). Работает с uppercase. */
export async function hyphenateRu(text: string): Promise<string> {
  if (!text?.trim()) return text;
  const fn = await initHyphenator();
  return fn(text);
}
